var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "#EC6321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17078",
    "data-name": "Groupe 17078",
    transform: "translate(-19.25 -18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(19.25 18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12032",
    "data-name": "Trac\\xE9 12032",
    d: "M26.224,21.141a8.372,8.372,0,0,1-2.974-6.406V11.25a8.757,8.757,0,0,0-7.5-8.65V1.25a1.25,1.25,0,1,0-2.5,0V2.6a8.756,8.756,0,0,0-7.5,8.65v3.485a8.382,8.382,0,0,1-2.985,6.416A2.187,2.187,0,0,0,4.188,25H24.813a2.187,2.187,0,0,0,1.411-3.859Z",
    transform: "translate(-2 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12033",
    "data-name": "Trac\\xE9 12033",
    d: "M12.918,24.75A4.7,4.7,0,0,0,17.511,21H8.326A4.7,4.7,0,0,0,12.918,24.75Z",
    transform: "translate(-0.418 5.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.72ae49df0f5abdd5e9bea1bef97595b7.svg";
export { ForwardRef as ReactComponent };